const falFileAlt = {
	icon: [
		384,
		512,
		[],
		'f15c',
		'M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z'
	],
	iconName: 'file-alt',
	prefix: 'fal'
};

const falFileCode = {
	icon: [
		512,
		512,
		[],
		'f1c9',
		'M 369.941 97.941 l -83.882 -83.882 A 48 48 0 0 0 252.118 0 H 48 C 21.49 0 0 21.49 0 48 v 416 c 0 26.51 21.49 48 48 48 h 288 c 26.51 0 48 -21.49 48 -48 V 131.882 a 48 48 0 0 0 -14.059 -33.941 Z m -22.627 22.628 a 15.89 15.89 0 0 1 4.195 7.431 H 256 V 32.491 a 15.88 15.88 0 0 1 7.431 4.195 l 83.883 83.883 Z M 336 480 H 48 c -8.837 0 -16 -7.163 -16 -16 V 48 c 0 -8.837 7.163 -16 16 -16 h 176 v 104 c 0 13.255 10.745 24 24 24 h 104 v 304 c 0 8.837 -7.163 16 -16 16 Z m -161.471 -67.404 l -25.928 -7.527 a 5.1 5.1 0 0 1 -3.476 -6.32 l 58.027 -199.869 a 5.1 5.1 0 0 1 6.32 -3.476 l 25.927 7.527 a 5.1 5.1 0 0 1 3.476 6.32 L 180.849 409.12 a 5.1 5.1 0 0 1 -6.32 3.476 Z m -48.446 -47.674 l 18.492 -19.724 a 5.101 5.101 0 0 0 -0.351 -7.317 L 105.725 304 l 38.498 -33.881 a 5.1 5.1 0 0 0 0.351 -7.317 l -18.492 -19.724 a 5.1 5.1 0 0 0 -7.209 -0.233 L 57.61 300.279 a 5.1 5.1 0 0 0 0 7.441 l 61.263 57.434 a 5.1 5.1 0 0 0 7.21 -0.232 Z m 139.043 0.232 l 61.262 -57.434 a 5.1 5.1 0 0 0 0 -7.441 l -61.262 -57.434 a 5.1 5.1 0 0 0 -7.209 0.233 l -18.492 19.724 a 5.101 5.101 0 0 0 0.351 7.317 L 278.275 304 l -38.499 33.881 a 5.1 5.1 0 0 0 -0.351 7.317 l 18.492 19.724 a 5.1 5.1 0 0 0 7.209 0.232 Z'
	],
	iconName: 'file-code',
	prefix: 'fal'
};

const falGrinHearts = {
	icon: [
		496,
		512,
		[],
		'f584',
		'M 248 8 C 111 8 0 119 0 256 s 111 248 248 248 s 248 -111 248 -248 S 385 8 248 8 Z m 0 464 c -119.1 0 -216 -96.9 -216 -216 S 128.9 40 248 40 s 216 96.9 216 216 s -96.9 216 -216 216 Z m 123.1 -151.2 C 340.9 330.5 296 336 248 336 s -92.9 -5.5 -123.1 -15.2 c -11.6 -3.7 -22.6 6.3 -20.7 17.9 c 9.2 55 83.2 93.3 143.8 93.3 s 134.5 -38.3 143.8 -93.3 c 1.9 -11.6 -9 -21.6 -20.7 -17.9 Z M 248 400 c -35 0 -77 -16.3 -98.5 -40.3 c 57.5 10.8 139.6 10.8 197.1 0 C 325 383.7 283 400 248 400 Z m -61.8 -128.8 c 14.3 3.7 27.2 -5.5 30.5 -17.6 l 20.5 -73.9 c 4.1 -14.7 1.7 -30.4 -6.5 -43.2 c -8.2 -12.8 -21.6 -21.5 -36.8 -23.9 c -25.2 -4.1 -49.4 10.7 -59.3 34 c -25.2 -3 -50.2 11 -59.1 34.3 c -5.5 14.4 -4.7 30.3 2.3 43.8 c 6.9 13.5 19.4 23.4 34.2 27.2 l 74.2 19.3 Z m -80.7 -78.8 c 5.2 -13.8 20.4 -15.5 28.5 -13.4 l 22.8 5.9 l 6.2 -22.7 c 3.3 -11.9 14.7 -19.7 25.9 -18 c 13.1 2.1 20.9 14.6 17.5 27 l -18.7 67.3 l -67.6 -17.5 c -12.1 -3.1 -19.4 -15.9 -14.6 -28.6 Z M 420.4 181 c -8.9 -23.3 -34.1 -37.3 -59 -34.3 c -9.9 -23.3 -34.7 -38.2 -59.3 -34 c -15.2 2.4 -28.6 11.1 -36.8 23.9 c -8.2 12.8 -10.6 28.5 -6.5 43.2 l 20.4 73.8 c 3.4 12.3 16.5 21.3 30.5 17.6 l 74.2 -19.2 a 53.47 53.47 0 0 0 34.2 -27.2 c 6.9 -13.5 7.8 -29.5 2.3 -43.8 Z m -44.5 40 l -67.7 17.5 l -18.7 -67.3 c -3.4 -12.3 4.4 -24.9 17.5 -27 c 13.7 -2.2 23.4 9 25.8 17.9 l 6.2 22.7 l 23 -5.8 c 12 -3.1 24.5 2.8 28.5 13.4 c 4.8 12.7 -2.5 25.5 -14.6 28.6 Z'
	],
	iconName: 'grin-hearts',
	prefix: 'fal'
};

const falSpinner = {
	icon: [
		512,
		512,
		[],
		'f110',
		'M288 32c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-32 416c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm256-192c0-17.673-14.327-32-32-32s-32 14.327-32 32 14.327 32 32 32 32-14.327 32-32zm-448 0c0-17.673-14.327-32-32-32S0 238.327 0 256s14.327 32 32 32 32-14.327 32-32zm33.608 126.392c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm316.784 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM97.608 65.608c-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32s32-14.327 32-32c0-17.673-14.327-32-32-32z'
	],
	iconName: 'spinner',
	prefix: 'fal'
};

const falArrowBack = {
	icon: [
		448,
		512,
		[],
		'f060',
		'M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'
	],
	iconName: 'arrow-left',
	prefix: 'fal'
};

const falFileArchive = {
	icon: [
		384,
		512,
		[],
		'f1c6',
		'M128 96v32h32V96zm65.9 169.6c-1.1-5.6-6-9.6-11.8-9.6H160v-32h-32v32l-19.4 97.2c-6.5 32.5 18.3 62.8 51.4 62.8s57.9-30.3 51.4-62.8zm-33.6 124.5c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zM128 160v32h32v-32zm64-96h-32v32h32zm177.9 33.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 32.5c2.8.7 5.4 2.1 7.4 4.2l83.9 83.9c2 2 3.5 4.6 4.2 7.4H256zM352 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h79.7v32h32V32H224v104c0 13.3 10.7 24 24 24h104zM192 192h-32v32h32zm0-64h-32v32h32z'
	],
	iconName: 'file-archive',
	prefix: 'fal'
};

const falQuestion = {
	icon: [
		384,
		512,
		[],
		'f128',
		'M200.343 0C124.032 0 69.761 31.599 28.195 93.302c-14.213 21.099-9.458 49.674 10.825 65.054l42.034 31.872c20.709 15.703 50.346 12.165 66.679-8.51 21.473-27.181 28.371-31.96 46.132-31.96 10.218 0 25.289 6.999 25.289 18.242 0 25.731-109.3 20.744-109.3 122.251V304c0 16.007 7.883 30.199 19.963 38.924C109.139 360.547 96 386.766 96 416c0 52.935 43.065 96 96 96s96-43.065 96-96c0-29.234-13.139-55.453-33.817-73.076 12.08-8.726 19.963-22.917 19.963-38.924v-4.705c25.386-18.99 104.286-44.504 104.286-139.423C378.432 68.793 288.351 0 200.343 0zM192 480c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm50.146-186.406V304c0 8.837-7.163 16-16 16h-68.292c-8.836 0-16-7.163-16-16v-13.749c0-86.782 109.3-57.326 109.3-122.251 0-32-31.679-50.242-57.289-50.242-33.783 0-49.167 16.18-71.242 44.123-5.403 6.84-15.284 8.119-22.235 2.848l-42.034-31.872c-6.757-5.124-8.357-14.644-3.62-21.677C88.876 60.499 132.358 32 200.343 32c70.663 0 146.089 55.158 146.089 127.872 0 96.555-104.286 98.041-104.286 133.722z'
	],
	iconName: 'question',
	prefix: 'fal'
};

export default [ falFileCode, falFileAlt, falFileCode, falGrinHearts, falSpinner, falArrowBack, falFileArchive, falQuestion ];